import { useGetSellerLoyaltyTransactions } from "hooks/seller";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { omit } from "utils/object";

export const useTable = () => {
  const { id } = useParams();
  const [params, setParams] = useState({
    filters: {
      sellerID: id,
      timeFilter: {
        from: null,
        to: null,
      },
      sortBy: "CREATED_AT_DESC",
    },
    pagination: { limit: 10, offset: 0 },
  });

  const { data, loading } = useGetSellerLoyaltyTransactions(params);

  const handleChangeTable = (pagination, _, sorter) => {
    const { current, pageSize } = pagination;
    let newParams = {
      ...params,
      pagination: { ...params?.pagination, offset: (current - 1) * pageSize },
      filters: {
        ...params?.filters,
        sortBy: sorter?.order === "ascend" ? "CREATED_AT_ASC" : "CREATED_AT_DESC",
      },
    };
    setParams(newParams);
  };

  const handleChangeDate = (value) => {
    const { from, to } = value;

    setParams({
      ...params,
      filters: {
        ...params?.filters,
        timeFilter: {
          from: from,
          to: to,
        },
      },
    });
  };

  const onChangeParams = (value) => {
    setParams({
      ...params,
      filters: {
        ...params.filters,
        ...value,
      },
    });
  };
  const handleChangeFilter = (key, value) => {
    onChangeParams && onChangeParams({ [`${key}`]: value });
  };

  const handleRemoveFilterTag = (key) => {
    setParams({
      pagination: { offset: 0, limit: 10 },
      filters: {
        ...omit({ ...params.filters }, [key]),
      },
      sorts: params?.sorts,
      activeKey: params.activeKey,
    });
  };

  return {
    loyaltyTransactions: data?.loyaltyTransactions,
    paginationData: data?.paginationData,
    loading,
    params,
    handleChangeFilter,
    handleChangeTable,
    handleChangeDate,
    handleRemoveFilterTag,
  };
};
